"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dayTimeSchema = exports.isValidDate = exports.isValidTime = void 0;
const zod_1 = require("../../zod");
const isValidTime = (time) => {
    const [hours, minutes] = time.split(':').map(Number);
    return hours >= 0 && hours < 24 && minutes >= 0 && minutes < 60;
};
exports.isValidTime = isValidTime;
const isValidDate = (date) => {
    const [day, month, year] = date.split('.').map(Number);
    const dateObj = new Date(year, month - 1, day);
    return dateObj.getFullYear() === year && dateObj.getMonth() + 1 === month && dateObj.getDate() === day;
};
exports.isValidDate = isValidDate;
exports.dayTimeSchema = zod_1.z.string().refine((val) => {
    // Validate date format as 'DD.MM.YYYY-HH:mm'
    const datePattern = /^\d{2}\.\d{2}\.\d{4}-\d{2}:\d{2}$/;
    const [datePart, timePart] = val.split('-');
    return datePattern.test(val) && (0, exports.isValidTime)(timePart) && (0, exports.isValidDate)(datePart);
}, {
    message: 'Date must be in the format DD.MM.YYYY-HH:mm',
});
